import NodeEmitter from './NodeEmitter';

// On-screen FPS / frame-time readout. Driven by the global rAF loop in app.js
// (so it measures every page, not just the portfolio). Hidden by default;
// press the backtick (`) key to show/hide. The "loop" line is the global rAF
// rate; the "webgl" line counts actual portfolio renders (capped to 60) via the
// 'webglRender' event — 0 on pages without the portfolio canvas.
export default class FPSMeter {
	constructor({ key = '`', visible = false } = {}) {
		this.key = key;
		this.visible = visible;

		this.frames = 0;
		this.renders = 0; // 'webglRender' events since last display refresh
		this.acc = 0; // ms accumulated since last display refresh
		this.last = performance.now();

		this._onRender = () => this.renders++;
		NodeEmitter.on('webglRender', this._onRender);

		this.el = document.createElement('div');
		Object.assign(this.el.style, {
			position: 'fixed',
			top: '8px',
			left: '8px',
			zIndex: 999999,
			font: '12px/1.3 monospace',
			color: '#0f0',
			background: 'rgba(0,0,0,0.7)',
			padding: '4px 6px',
			borderRadius: '4px',
			pointerEvents: 'none',
			whiteSpace: 'pre',
			display: visible ? 'block' : 'none',
		});
		this.el.textContent = 'fps —';
		document.body.appendChild(this.el);

		this._onKey = (e) => {
			if (e.key === this.key) this.toggle();
		};
		window.addEventListener('keydown', this._onKey);
	}

	toggle(v = !this.visible) {
		this.visible = v;
		this.el.style.display = v ? 'block' : 'none';
	}

	// Call once per rAF frame. `now` is the rAF timestamp (same clock as
	// performance.now); falls back when called manually without an arg.
	tick(now = performance.now()) {
		this.frames++;
		this.acc += now - this.last;
		this.last = now;

		if (this.acc >= 500) {
			// refresh the readout twice a second
			if (this.visible) {
				const fps = (this.frames * 1000) / this.acc;
				const ms = this.acc / this.frames;
				const rfps = (this.renders * 1000) / this.acc;
				this.el.textContent = `loop ${fps.toFixed(0)} fps  ${ms.toFixed(2)} ms\nwebgl ${rfps.toFixed(0)} fps`;
			}
			this.frames = 0;
			this.renders = 0;
			this.acc = 0;
		}
	}

	destroy() {
		window.removeEventListener('keydown', this._onKey);
		NodeEmitter.off('webglRender', this._onRender);
		this.el.remove();
	}
}
